import { connect } from 'react-redux';
import CheckoutForm from '../components/Checkout/CheckoutForm';
import { removeItem, requestCart } from '../actions/cartActions';
import { requestDisPatchLocationFilter, requestPurchasingUserInfo, submitAccountHolderInformation } from '../actions/userActions';
import { getPurchasingMemberType } from '../selectors/converterSelector';
import { getAddressList } from '../selectors/addressSelector';
import {
    getCurrentlyPurchasingUser,
    getSelectedSupplierInfoAddressList,
    getDispatchLocations,
    getDefaultDispatchLocationID,
} from '../selectors/userSelector';

const mapStateToProps = function(store) {
    const user = getCurrentlyPurchasingUser(store);
    const userAddresses = getAddressList(
        user.info.availableAddresses,
        store.address.list
    );
    const supplierAddressList = getAddressList(
        getSelectedSupplierInfoAddressList(user),
        store.address.list
    );

    const dispatchLocations = getDispatchLocations(store);
    user.info.availableDispatchLocations;
    const defaultDisaptchLocationID = getDefaultDispatchLocationID(store);
    
    return {
        globalConfig: store.globalConfig.data,
        user: user.info,
        memberType: getPurchasingMemberType(store), // Get the currently logged in member type
        billingAddresses: userAddresses,
        allAddresses: [...userAddresses, ...supplierAddressList],
        isUserLoading: user.isLoading.basicInfo,
        isDispatchLoading: store.user.isLoading.dispatchLocationList,
        isCartLoading: store.cart.isLoading,
        detail: store.cart.detail,
        currencyFormat: store.cart.currencyFormat,
        currencyDisplayCode: store.cart.currencyDisplayCode,
        locale: store.cart.locale,
        orderOnBehalf: store.user.orderOnBehalf,
        canUseSavedCard: store.user.orderOnBehalf === false,
        allowAddNewAddress: true,
        showDeliveryAddressDropdown: store.user.orderOnBehalf === true,
        dispatchLocations: dispatchLocations,
        defaultDisaptchLocationID: defaultDisaptchLocationID,
    };
};
const mapDispatchToProps = function(dispatch, ownProps) {
    return {
        removeItem: (item, callback) => dispatch(removeItem(item, callback)),
        requestCart: () => dispatch(requestCart()),
        requestUserInfo: (offset, limit, search, type) =>
            dispatch(requestPurchasingUserInfo(offset, limit, search, type)),
            submitAccountHolderInformation: (formData, callback) =>
            dispatch(submitAccountHolderInformation(formData, callback)),
        requestDisPatchLocationFilter: (limit, search) =>
            dispatch(requestDisPatchLocationFilter(limit, search)),
    };
};
const ConnectedCheckoutForm = connect(
    mapStateToProps,
    mapDispatchToProps
)(CheckoutForm);

export default ConnectedCheckoutForm;
